import { City, Country, Municipality, Region } from '../customer/modals/EditAddressModal';
import { ProductDesign } from '../productDesign/ProductDesignForm';
import Product from '../products/Product';

export interface BillingAddress {
	id: string;
	street: string;
	number: string;
	zip: string;
	vatNumber: string;
	phone?: string;
	isDefault: boolean;
	disabled: boolean;
	deletedAt: Date | null;
	comment: string | null;
	country: Country;
	region: Region;
	municipality: Municipality;
	city: City;
	customer: Customer;
}
export interface ShippingAddress {
	id: string;
	street: string;
	number: string;
	zip: string;
	vatNumber: string;
	phone?: string;
	isDefault: boolean;
	disabled: boolean;
	deletedAt: Date | null;
	comment: string | null;
	country: Country;
	region: Region;
	municipality: Municipality;
	city: string;
	customer: Customer;
}

export interface Currency {
	id: string;
	name: string;
	symbol: string;
	disabled: boolean;
	deletedAt: Date | null;
}

export interface User {
	id: string;
	email: string;
}

export interface Customer {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	user: User;
	company: string;
	disabled: boolean;
	deletedAt: Date | null;
}

export interface PaymentType {
	id: string;
	name: string;
	description: string;
	priority: number;
	disabled: boolean;
	deletedAt: Date | null;
}

export interface ShippingOption {
	id: string;
	name: string;
	description: string;
	ordinal: number;
	shippingCost: number;
	disabled: boolean;
	deletedAt: Date | null;
}

export interface Zone {
	id: string;
	zoneName: string;
	disabled: boolean;
	deletedAt: Date | null;
}

export interface Order {
	id: string;
	orderNo: string;
	billingAddress: BillingAddress;
	comments: OrderComment[];
	createdAt: Date;
	currency: Currency;
	customer: Customer;
	differentAddress: boolean;
	disabled: boolean;
	fulfilledAt: Date | null;
	isPaid: boolean;
	orderItems: OrderItem[];
	numberOfItems: number;
	orderStatus: OrderStatusEnum;
	orderTrackingCode: string;
	origin: string;
	paymentReference: string;
	paymentStatus: PaymentStatusEnum;
	paymentType: PaymentType;
	shippingAddress: ShippingAddress;
	shippingCost: string;
	shippingOption: ShippingOption;
	shippingStatus: ShippingStatusEnum;
	totalTax: string;
	totalValue: string;
	vatNo: string;
	statusLogs: StatusLog[];
}

export interface OrderComment {
	id: string;
	commentText: string;
	createdAt: string;
	isPrivate: boolean;
	createdBy: string;
	orderId: string;
}

export interface OrderItem {
	id: string;
	order: Order;
	orderDesign: ProductDesign;
	sku: string;
	products: Product;
	quantity: number;
	cost: number;
	regularPrice: number;
	tax: string;
	itemTotal: number;
	disabled: boolean;
}

export interface StatusLog {
	id: string;
	user: User;
	oldStatus: OrderStatusEnum;
	newStatus: OrderStatusEnum;
	order: Order;
	date: Date;
}

export enum OrderStatusEnum {
	'CREATED',
	'IN FULFILLMENT',
	'ON HOLD',
	'SHIPPED',
	'DELIVERED',
	'RETURNED',
	'REFUNDED',
	'CANCELED',
}

export enum PaymentStatusEnum {
	'PAID IN FULL',
	'PAID PARTIALLY',
	'NOT PAID',
	'REFUNDED',
}

export enum ShippingStatusEnum {
	'IN PREPARATION',
	'SHIPPED',
	'RETURNED',
	'CANCELLED',
	'REFUNDED',
}
